import React from 'react';
import SmallCardInfo from 'components/SmallCardInfo';
import LinksInfo from 'components/LinksInfo';
import MapAddress from 'components/MapAddress';

import phone from 'images/icons/call-outline.svg';
import location from 'images/icons/location-outline.svg';
import email from 'images/icons/mail-outline (1).svg';

type ContactUsProps = {
  id: string,
}

const ContactUs: React.FC<ContactUsProps> = ({ id }) => {

  const featureCards = [
    { img: location, title: 'Head Office', firstDcp: '68 Commercial Drive Shailer Park QLD 4128', secondDcp: '' },
    { img: phone, title: 'Phone', firstDcp: '1300 359 994', secondDcp: 'Mon-Fri 7:30am – 5:00pm AEST' },
    { img: email, title: 'Mail', firstDcp: 'infocus@endataclaims.com', secondDcp: '' },
  ]

  const titles =  {
    cuTitle: 'Contact Us'
}



  return (
    <div id={id} className="w-full mt-5">
      <div className="">
        <div className="text-center">
          <div className="text-4xl font-bold pt-3">{titles.cuTitle}</div>
        </div>
        <div className="lg:flex justify-center sm:mx-5 md:mx-32 lg:mx-64">
          {featureCards.map((item, index) => {
            return <SmallCardInfo style={{flex:1}} className="col-span-1" key={index} img={item.img} title={item.title} firstDcp={item.firstDcp} secondDcp={item.secondDcp} />
          })}
        </div>
        <div className=''>
          <LinksInfo />
        </div>
      </div>

      <div className='mt-10'>
        <MapAddress />
      </div>
    </div>
  )
}

export default ContactUs;